import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/parking.js';
import q from '../query.js';
export const parkingLotRemarksEntity = 'parking-lot-remarks';
const parkingLotRemarksKey = (parkingLotReferenceId) => `parking-lot-remarks-${parkingLotReferenceId}`;
export const useParkingLotRemarks = (parkingLotReferenceId) => q.query(parkingLotRemarksKey(parkingLotReferenceId), () => api.getParkingLotRemarks(parkingLotReferenceId), keys.read.collection(parkingLotRemarksEntity), {
    enabled: parkingLotReferenceId != null,
});
//# sourceMappingURL=index.js.map